import React from "react";
import { Alert } from "@material-ui/lab";
import RefreshIcon from "@material-ui/icons/Refresh";
import { LoadingSpinner } from "../../../utils/LoadingSpinner";
import { COLORS } from "../styles/theme";
import { AUTO_RETRY_INTERVAL_MS, IPrescriptionLookup } from "../hooks/usePrescriptionLookup";
import StyledActionButton from "./StyledActionButton";

interface IProps {
  lookup: IPrescriptionLookup;
  drugDescription?: string;
}

const statusMessage = (lookup: IPrescriptionLookup, drugDescription?: string) => {
  const drug = drugDescription ? ` ("${drugDescription}")` : "";
  if (lookup.lookupErrorMessage) {
    return (
      `Failed to retrieve prescriptions: ${lookup.lookupErrorMessage.replace(/\.?\s*$/, ".")} ` +
      `Click Refresh to try again, or enter the prescription details manually below.`
    );
  }
  if (lookup.isAutoRetrying) {
    return (
      `Waiting for the prescription${drug} to be ready. Checking again every ` +
      `${AUTO_RETRY_INTERVAL_MS / 1000}s, so the Prescription ID fills in automatically.`
    );
  }
  return (
    `Could not find the prescription for the medication added in the previous steps${drug}. ` +
    `It may still be processing. Wait a moment and click Refresh, or enter the prescription details manually below.`
  );
};

const PrescriptionLookupStatus: React.FC<IProps> = ({ lookup, drugDescription }) => {
  if (lookup.isLookingUp) {
    return <LoadingSpinner />;
  }
  if (!lookup.lookupFailed) {
    return null;
  }
  const severity = lookup.lookupErrorMessage ? "error" : lookup.isAutoRetrying ? "info" : "warning";
  return (
    <div style={{ marginBottom: 16 }}>
      <Alert severity={severity}>{statusMessage(lookup, drugDescription)}</Alert>
      <div style={{ marginTop: 16 }}>
        <StyledActionButton
          label="Refresh"
          onClick={lookup.refresh}
          color={COLORS.orange}
          startIcon={<RefreshIcon />}
        />
      </div>
    </div>
  );
};

export default PrescriptionLookupStatus;
